// src/components/ConferencesCarousel.js
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper/modules";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/mousewheel";
import "./ConferencesCarousel.css";

// ✅ API base URL (öncelikle .env'den, yoksa fallback olarak Firebase URL)
const API_URL =
  process.env.REACT_APP_API_URL?.trim() ||
  "https://us-central1-ottomun-87f07.cloudfunctions.net/api/api";

const ConferencesCarousel = () => {
  const [conferences, setConferences] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConferences = async () => {
      try {
        const response = await fetch(`${API_URL}/conferences`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setConferences(data);
      } catch (error) {
        console.error("❌ Error fetching conferences:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchConferences();
  }, []);

  if (loading) {
    return (
      <section className="carousel-section">
        <h2>Our Conferences</h2>
        <p className="loading-text">Loading conferences...</p>
      </section>
    );
  }

  if (!conferences.length) {
    return (
      <section className="carousel-section">
        <h2>Our Conferences</h2>
        <p className="empty-text">No conferences available yet.</p>
      </section>
    );
  }

  return (
    <section className="carousel-section">
      <h2>Our Conferences</h2>
      <Swiper
        modules={[Mousewheel]}
        slidesPerView={4}
        spaceBetween={40}
        grabCursor
        centeredSlides
        mousewheel={{ forceToAxis: true }}
        loop
        speed={600}
        className="conferenceSwiper"
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 20 },
          600: { slidesPerView: 2, spaceBetween: 25 },
          900: { slidesPerView: 3, spaceBetween: 35 },
          1200: { slidesPerView: 4, spaceBetween: 40 },
        }}
      >
        {conferences.map((conf) => (
          <SwiperSlide key={conf.id}>
            <div className="conference-card">
              <img
                src={
                  conf.image?.trim()
                    ? conf.image
                    : "https://picsum.photos/300/200?random=1"
                }
                alt={conf.title || "Conference Image"}
              />
              <h3>{conf.title}</h3>
              <p>{conf.date}</p>
              <Link to={`/conference/${conf.id}`} className="details-btn">
                View Details
              </Link>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default ConferencesCarousel;
